export const PUBLISHERS = {
  MLADINSKA: 'Mladinska knjiga',
  VICENS_VIVES: 'Vicens Vives',
}
